import { enableBodyScroll } from 'body-scroll-lock';
import { buildProductTiles, setFilteredProducts, getNextSetOfProducts, setNextPageSearch, getCurrentPageSearch, setNbHitsSearch, setCurrentPageSearch, per_page } from '../../sections/collection/filteredCollection';
import { initNumberedPagination } from '../../sections/collection/actions';
import { truncateString } from '../../core/helpers';
import scrollToCurrentTop from './scroll';
import initFilteringOptions from '../filtering-sorting/initFilteringOptions';

export default class FullSearch {
  elements;
  search_value;
  search_results;
  products_json;

  constructor() {
    this.search_value = '';
    this.search_results = null;
    this.products_json = null;
  }

  initFullSearch = () => {
    if (typeof this.elements === 'undefined' || this.elements === null) {
      this.elements = {
        overlayElement: document.querySelector('[data-overlay-search]'),
        filterByElement: document.querySelector('[data-overlay-search-filter-by]'),
        searchResultsElement: document.querySelector('[data-overlay-search-results]'),
        filtersPanelElement: document.querySelector('[data-overlay-search-form] [data-filters-panel-v3]'),
        searchTotalElements: document.querySelectorAll('[data-overlay-search-total], [data-mobile-overlay-search-filter-nav-view-results-count]'),
        searchTerms: document.querySelector('[data-overlay-search-terms]'),
        // loadMoreButton: document.querySelector('[data-overlay-search-load-more]'),
        containerGridElement: document.querySelector('[data-overlay-search-grid-container] .grid'),
      };
    }

    if (window.theme.search.full_search_init === false) {
      window.theme.search.full_search_init = true;

      // if (this.elements.loadMoreButton !== null) {
      //   this.elements.loadMoreButton.addEventListener('click', this.handleLoadMoreButton);
      // }

      document.addEventListener('click', async (e) => {
        const target = e.target.closest('[data-overlay-search-pagination-first], [data-overlay-search-pagination-last], [data-overlay-search-pagination-next], [data-overlay-search-pagination-previous]');

        if (!target || target.classList.contains('disabled')) {
          return;
        }

        if (target.matches('[data-overlay-search-pagination-first]')) {
          setCurrentPageSearch(1);
        } else if (target.matches('[data-overlay-search-pagination-last]')) {
          const total_pages = Math.ceil(window.theme.search.total_results / per_page);
          setCurrentPageSearch(total_pages);
        } else if (target.matches('[data-overlay-search-pagination-next]')) {
          const total_pages = Math.ceil(window.theme.search.total_results / per_page);
          let current_page = getCurrentPageSearch();
          current_page++;
          if (current_page > total_pages) {
            current_page = total_pages;
          }
          setCurrentPageSearch(current_page);
        } else if (target.matches('[data-overlay-search-pagination-previous]')) {
          let current_page = getCurrentPageSearch();
          current_page--;
          if (current_page < 0) {
            current_page = 0;
          }
          setCurrentPageSearch(current_page);
        }

        const event = new CustomEvent('astr-nosto-pagination', { bubbles: true });
        document.dispatchEvent(event);
      });

      document.addEventListener('pagination:page-overlay-search-click', async (e) => {
        console.log('e.detail', e.detail);
        const { page } = e.detail;
        if (!page) return;
        setCurrentPageSearch(page);
        const event = new CustomEvent('astr-nosto-pagination', { bubbles: true });
        document.dispatchEvent(event);
      });
    }
  };

  // destroy = () => {
  //   if (this.elements?.loadMoreButton) {
  //     this.elements.loadMoreButton.removeEventListener('click', this.handleLoadMoreButton);
  //   }
  // };

  // Reset the search elements with every new search request
  resetSearchElements = () => {
    this.initFullSearch();

    window.theme.search.page = 1;
    window.theme.search.products = [];
    window.theme.search.filtering = [];
    window.theme.search.sorting = 'manual';

    // Reset the selected filters
    const selected_filters_elements = document.querySelectorAll(`[data-overlay-search-selected-filters]`);
    selected_filters_elements.forEach(filters_elements => {
      filters_elements.classList.remove('active');
    });

    const filter_lists = document.querySelectorAll(`[data-overlay-search-selected-filters-list]`);
    if (filter_lists.length) {
      filter_lists.forEach(list => {
        const items = list.querySelectorAll(`[data-overlay-search-selected-filters-item]`);
        items.forEach(item => item.remove());
      });
    }

    // Remove all filter options but the all filters button and sort by
    const filter_by_children = Array.from(this.elements.filterByElement.querySelectorAll('.filter-option'));
    filter_by_children.forEach(child => {
      if (!child.matches('[data-overlay-search-show-all-filters]') && !child.matches('[data-filter-options-type="sorting"]')) {
        child.remove();
      }
    });

    setNextPageSearch(true);
    this.elements.searchResultsElement.querySelector('.grid').innerHTML = '<img src="https://cdn.shopify.com/s/files/1/2483/6632/files/loader.gif?v=1729708185" alt="Loading, please wait..." width="50" height="50" class="overlay-search__loader" />';
    this.elements.filterByElement.classList.remove('loaded');
    this.elements.searchResultsElement.classList.remove('results-visible');
    this.elements.searchResultsElement.classList.remove('loaded');
    this.elements.filtersPanelElement.classList.remove('loaded');
  };

  // Prepare the overlay elements after the search has been performed by suggestions-search.js
  fullSearchPerformed = async (response) => {
    this.search_results = response;
    console.log('[ASTR] Full search performed', this.search_results);
    window.theme.search.total_results = this.search_results?.products?.total ?? 0;

    this.initFullSearch();

    this.elements.overlayElement.classList.add('results-visible');
    this.elements.searchResultsElement.classList.add('loaded');
    this.elements.filtersPanelElement.classList.add('loaded');
    document.querySelector('[data-overlay-search] [data-show-mobile-filter-nav]')?.parentElement?.classList.add('visually-hidden');

    // We need to be able to scroll the page when mobile nav is opened
    if (document.querySelector('html').classList.contains('mobile-nav-opened')) {
      enableBodyScroll(document.querySelector('[data-mobile-nav]'));
      document.querySelector('html').classList.add('force-scroll');
    }

    // Reset the displayed data
    this.elements.searchTotalElements.forEach(element => {
      if (element.matches('[data-mobile-overlay-search-filter-nav-view-results-count]')) {
        element.innerHTML = `(${window.theme.search.total_results})`;
      } else {
        element.innerHTML = window.theme.search.total_results;
      }
    });
    this.elements.overlayElement.classList.remove('no-results');

    if (window.theme.search.total_results === 0) {
      this.elements.overlayElement.classList.add('no-results');
    }
    this.elements.searchTerms.innerHTML = truncateString(this.search_results.query, 25);

    if (window.theme.search.total_results > 0) {
      await this.searchHasResults();
      return;
    }

    this.searchHasNoResults();
  };

  pagedSearchPerformed = async (response) => {
    console.log('pagedSearchPerformed', window.theme.search.page, window.theme.collections.page);
    // if (
    //   !response ||
    //   !response.products ||
    //   !Array.isArray(response.products.hits) ||
    //   !this.search_results ||
    //   !this.search_results.products ||
    //   !Array.isArray(this.search_results.products.hits)
    // ) {
    if (
      !response ||
      !response.products ||
      !Array.isArray(response.products.hits)) {
      console.warn('[full-search.js] Invalid response or products in pagedSearchPerformed:', response, this.search_results);
      return;
    }

    // When on page > 1 and sorting, we need to ensure that the search results are initialized
    if (this.search_results === null) {
      this.search_results = {
        products: {
          hits: [],
          total: 0,
          facets: []
        }
      };
    }

    console.log('[ASTR] Paged search performed', this.search_results);

    // if (!this.elements || !this.elements.loadMoreButton) {
    //   console.warn('[FullSearch] Load More Button is not found in the DOM.');
    //   return;
    // }

    // if (response.products.hits.length < window.theme.search.products_per_page) {
    //   this.elements.loadMoreButton.classList.add('hide');
    // }

    this.search_results.products.hits = [...this.search_results.products.hits, ...response.products.hits];
    window.theme.search.products = this.search_results.products.hits;
    this.search_results.total = this.search_results.products.hits.length;

    setFilteredProducts(window.theme.search.products);
    getNextSetOfProducts(false);
    await buildProductTiles(!(window.theme.breakpoints.current === 'mobile'), true, 'search-pagination', 'pagedSearchPerformed');
    initNumberedPagination(response.products.total);

    // if (window.theme.breakpoints.current === 'mobile') {
    // [ADA] Focus 1st element
    if (document.querySelectorAll('[data-overlay-search-grid-container] [data-product-tile]').length > 0) {
      document.querySelectorAll('[data-overlay-search-grid-container] [data-product-tile]')[0].focus();
    }
    // }
  };

  searchHasResults = async () => {
    setNbHitsSearch(window.theme.search.total_results);
    const nosto_products = this.search_results?.products?.hits ?? [];

    window.theme.search.products = nosto_products;

    // We don't want to refresh the filters if we're already filtering
    if (!window.theme.search.filtering.length) {
      window.theme.search.facets = this.search_results?.products?.facets ?? [];
      initFilteringOptions();
    }

    scrollToCurrentTop();
    setFilteredProducts(nosto_products);
    getNextSetOfProducts(true);
    await buildProductTiles(false, true, 'search', 'searchHasResults');

    this.elements.filterByElement.classList.add('loaded');
    document.querySelector('[data-overlay-search] [data-show-mobile-filter-nav]')?.parentElement?.classList.remove('visually-hidden');
    initNumberedPagination(this.search_results?.products?.total);

    document.querySelector('[data-overlay-search-results]')?.classList.add('results-visible');
  };

  // This case shouldn't happen anymore since we use the suggestions first
  searchHasNoResults = () => {
    console.log('[ASTR] Search has no results');

    if (window.theme.search.filtering.length) {
      this.elements.filterByElement.classList.add('loaded');
    }

    // this.elements.loadMoreButton.classList.add('hide');
    this.elements.containerGridElement.innerHTML = '<div class="column-xs-12">Sorry, no products matched your selection</div>';
    scrollToCurrentTop();
    initNumberedPagination(0);

    document.querySelector('[data-overlay-search-results]')?.classList.add('results-visible');
  };

  // Load more search on desktop
  // handleLoadMoreButton = async () => {
  //   setNextPageSearch();
  //   window.theme.search.page = getCurrentPageSearch();

  //   const event = new CustomEvent('astr-nosto-pagination', { bubbles: true });
  //   document.dispatchEvent(event);
  // };
}
